export default {"src":"/_next/static/media/take-breaks.8f36894d.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};